var React = require('react');

function Mu (props) {
    return React.createElement("svg",props,React.createElement("g",{"fillRule":"evenodd"},[React.createElement("path",{"fill":"#00a04d","d":"M0 360h640v120H0z","key":0}),React.createElement("path",{"fill":"#151f6d","d":"M0 120h640v120H0z","key":1}),React.createElement("path",{"fill":"#ee2737","d":"M0 0h640v120H0z","key":2}),React.createElement("path",{"fill":"#ffcd00","d":"M0 240h640v120H0z","key":3})]));
}

Mu.defaultProps = {"viewBox":"0 0 640 480"};

module.exports = Mu;

Mu.default = Mu;
